// extracted by mini-css-extract-plugin
module.exports = {"event-waitlist-description":"event-waitlist-description__2wdf3","title":"title__23vl_","list":"list__bDdab","note":"note__a1ETd"};